import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#f0fdf4] py-20 sm:py-24" aria-labelledby="garantia-title" data-id="element-47" data-mp="4uqcgsut9wrq">
      <div className="mx-auto w-full max-w-2xl px-6 text-center" data-id="element-48" data-mp="9umggs3ido7a">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border-2 border-[#16a34a]/25 bg-white" aria-hidden="true" data-id="element-49" data-mp="9wfs6lszaym5">
          <ShieldCheckIcon className="h-10 w-10 text-[#16a34a]" strokeWidth={1.75} data-id="element-50" data-mp="jtbzio755ep4" />
        </span>
        <h2 id="garantia-title" className="mt-8 font-serif text-3xl font-bold leading-tight text-[#0f172a] sm:text-4xl" data-id="element-51" data-mp="ntcdk7qbvnvn">
          Garantía de 7 Días Sin Preguntas
        </h2>
        <p className="mt-6 text-base leading-relaxed text-slate-600" data-id="element-52" data-mp="xjnwb0eo81ml">
          Si en los primeros 7 días de implementación no bajás al menos un 20% tu
          ticket de compra semanal, te devolvemos el 100% del dinero sin hacer ninguna
          pregunta. El sistema funciona o no pagás. Así de simple.
        </p>
      </div>
    </section>;
}